export default Object.freeze({
	Mobile: 0,
	Desktop: 1,
	Tablet: 2,
	DesktopModal: 3,
	TabletModal: 4,
});
